import { render, staticRenderFns } from "./CardMember.vue?vue&type=template&id=30d8b424&scoped=true"
import script from "./CardMember.vue?vue&type=script&lang=js"
export * from "./CardMember.vue?vue&type=script&lang=js"
import style0 from "./CardMember.vue?vue&type=style&index=0&id=30d8b424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d8b424",
  null
  
)

export default component.exports